import { dbuiV1QueryGenerateStatusOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetQueryStatus = ({
  id,
  disabled,
}: {
  id: string | undefined;
  disabled?: boolean;
}) => {
  const { workspace } = useWorkspace();
  return useQuery({
    ...dbuiV1QueryGenerateStatusOptions({
      ...defaultOptions(),
      path: { workspace, id: id! },
    }),
    enabled: !!workspace && !!id && !disabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    refetchInterval: 1000,
  });
};
